import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { httpOptionsForFileManagement } from "src/app/app.constants";

/**
 * Revokes the current access token server-side via File Operations logout API
 * (adds jti to the revoked-tokens blocklist). Call before Okta signOut so the
 * token cannot be reused after logout (CITI VA / session invalidation).
 */
@Injectable({
	providedIn: "root",
})
export class FileOperationsLogoutService {

	private static readonly LOGOUT_PATH = "fileoperationsservice/logout";

	constructor(private readonly httpClient: HttpClient) {}

	/**
	 * POSTs the current Bearer token to File Ops logout. Safe when not authenticated
	 * or on request failure; always completes without throwing.
	 */
	revokeTokenBeforeLogout(): Observable<void> {
		return this.httpClient.post(
			FileOperationsLogoutService.LOGOUT_PATH,
			null,
			httpOptionsForFileManagement()
		).pipe(
			map((): void => undefined),
			catchError((): Observable<void> => of(undefined))
		);
	}
}
